export function Loader() {
  return (
    <div
      data-testid="loader-container"
      className="flex h-screen items-center justify-center"
    >
      <div
        data-testid="loader-spinner"
        className="h-8 w-8 animate-spin rounded-full border-4 border-[var(--primary)] border-t-transparent"
      ></div>
    </div>
  );
}
